import { types } from './actions';

const timeEntryForm = (state = {}, action) => {
  switch (action.type) {
    case types.INIT: {
      const { data } = action;
      return {
        data,
      };
    }
    case types.SET_API_ERROR_MESSAGE: {
      const { APIErrorMessage } = action;
      return {
        ...state,
        APIErrorMessage,
      };
    }
    default:
      return state;
  }
};

export default timeEntryForm;
